import * as SQLite from 'expo-sqlite';
// Asume que tienes una forma de leer el CSV localmente (ej: expo-file-system)
import * as FileSystem from 'expo-file-system';
import { config } from 'app/configGlueStack/gluestack-ui.config';
import { ta } from 'date-fns/locale';


const CREATE_MAIN_TABLE = `
    CREATE TABLE IF NOT EXISTS main_table (
        medidor TEXT PRIMARY KEY, 
        tipo TEXT, 
        calle TEXT, 
        altura INTEGER, 
        piso TEXT, 
        departamento TEXT, 
        tarifa TEXT, 
        latitud REAL, 
        longitud REAL, 
        localidad TEXT
    );
`;

// Creamos índices para optimizar la búsqueda por rango (Bounding Box)
const CREATE_LAT_INDEX = `CREATE INDEX IF NOT EXISTS idx_lat ON main_table(latitud);`;
const CREATE_LON_INDEX = `CREATE INDEX IF NOT EXISTS idx_lon ON main_table(longitud);`;


const DB_NAME = 'Integrations.db';


export const initTable = async () => {
    const db = SQLite.openDatabase(DB_NAME);
    await db.execAsync([
        { sql: CREATE_MAIN_TABLE, args: [] },
        { sql: CREATE_LAT_INDEX, args: [] },
        { sql: CREATE_LON_INDEX, args: [] }
    ], false);
    console.log("Esquema e índices iniciales configurados.");
}

export const configTable = async (tableName, colsDef) => {
    const db = SQLite.openDatabase(tableName + ".db");
    let createTableSQL = `CREATE TABLE IF NOT EXISTS ${tableName} (`;
    createTableSQL += colsDef.map(col => `${col.name} ${col.type}  ${col.pk ? "PRIMARY KEY" : ""}`).join(', ');
    createTableSQL += ');';
    const createIndexSQL = colsDef.map(col => col.index ? `CREATE INDEX IF NOT EXISTS idx_${col.name} ON ${tableName}(${col.name});;\n` : "").join('');

    console.log("Esquema e índices", tableName, "\n", createTableSQL, "\n", createIndexSQL);
    await db.execAsync([
        { sql: createTableSQL, args: [] },
        { sql: createIndexSQL, args: [] }
    ], false);
    console.log("Esquema e índices iniciales configurados.2");
    db.closeAsync()
}
export const updTableFromFileContent = async (tenantId,s3Info, fileUri) => {
    const db = SQLite.openDatabase(`${tenantId}_${s3Info.tableName}.sqlite`);
    const fileContent = await FileSystem.readAsStringAsync(fileUri);
    const lines = fileContent.split('\n');
    const columns = s3Info.columns.map(col => col.name).join(', ');
    const placeholders = s3Info.columns.map(() => '?').join(', ');
    const INSERT_SQL = `INSERT OR REPLACE INTO data (${columns}) VALUES (${placeholders});`;
    const primaryKey = s3Info.columns.find(col => col.pk).name;
    const deleteSQL = `DELETE FROM data WHERE ${primaryKey} = @${primaryKey};`;
    await db.transactionAsync(async tx => {
        for (let i = 1; i < lines.length; i++) {
            const line = lines[i];
            const parts = line.split(s3Info.separator).map(s => s.trim());
            if (parts.length < s3Info.columns.length) continue;
            let values = [];
            let sqlToExecute = INSERT_SQL
            if (parts[0] == "-") {
                parts.shift();
                sqlToExecute = deleteSQL;
                const index = s3Info.columns.findIndex(col => col.pk);
                const colType = s3Info.columns[index].type.toUpperCase();
                values = [parts[index]];

                if (colType.includes('INTEGER')) values = [parseInt(parts[index])];
                if (colType.includes('REAL')) values = [parseFloat(parts[index])];

            } else {
                parts.shift();
                values = parts.map((part, index) => {
                    const colType = s3Info.columns[index].type.toUpperCase();
                    if (colType.includes('INTEGER')) return parseInt(part);
                    if (colType.includes('REAL')) return parseFloat(part);
                    return part; // TEXT u otros tipos
                });
            }

            await tx.executeSqlAsync(sqlToExecute, values);

        }
    }).catch(transactionError => {
        console.error('La transacción falló y se revirtió (ROLLBACK):', transactionError.message);
    });
/* 
    try {
        await db.execAsync([{ sql: 'VACUUM;', args: [] }], false);
        console.log('Database vacuumed successfully.');
    } catch (error) {
        console.error('Error vacuuming database:', error);
    } */
    db.closeAsync();
}


export const getDbConnection = (tableName) => {
    console.log("getDbConnection", tableName);
    const db = SQLite.openDatabase(tableName + ".sqlite");
    return db;
}

export const loadFromDownloaded = async (downloadedUri, tableName) => {
    // La ubicación nativa que expo-sqlite monitorea es: <DocumentDirectory>/SQLite/master.sqlite
    const finalDbDirectory = downloadedUri;
    const finalDbPath = `${FileSystem.documentDirectory}SQLite/${tableName}.sqlite`;
    let fileInfo = await FileSystem.getInfoAsync(downloadedUri);
    if (fileInfo.exists) {
        const sizeBytes = fileInfo.size;
        const sizeMB = (sizeBytes / (1024 * 1024)).toFixed(2);
        console.log(`✅ El archivo ${downloadedUri} existe.`);
        console.log(`📏 Ocupa: ${sizeMB} MB`);
    } else {
        console.log(`❌ El archivo ${downloadedUri} NO existe.`);

    }

    try {
        await FileSystem.makeDirectoryAsync(finalDbDirectory, { intermediates: true });
    } catch (e) {
        // Ignorar si el directorio ya existe
    }


    try {
        await FileSystem.deleteAsync(finalDbPath);
    } catch (e) {
        // Ignorar si no existe, es la primera vez
    }

    await FileSystem.copyAsync({
        from: downloadedUri,
        to: finalDbPath,
    });

    console.log(`3. DB movida y lista.`);

    // 2. Abrir la base de datos (ya está pre-indexada y lista para usar)
    const db = await SQLite.openDatabase(tableName + ".sqlite");
    let a = await db.execAsync([{ sql: "SELECT name FROM sqlite_master WHERE type='table';", args: [] }], false)
    console.log(a[0].rows);
    db.closeAsync();
    console.log(`4. DB abierta y cerrada para inicializar conexión: ${tableName}.sqlite`);
    return true;
};